import React, { ReactNode } from "react"
import ClassNames from "classnames"
import { Disclaimer } from "components/organisms/panel/disclaimer"
import { CommonDisclaimerText } from "config/disclaimerText"

type MainContainerTypeProps = {
  className?: string
  blockClassName?: string
  children?: ReactNode
}

export const MainContainer: React.FC<MainContainerTypeProps> = props => {
  return (
    <div className={ClassNames("main-container", props.className)}>
      <div
        className={ClassNames("scroll-block", props.blockClassName)}
        id="scroll"
      >
        <div className="contents-layout">{props.children}</div>
        {/* disclaimer */}

        <Disclaimer />
      </div>
    </div>
  )
}
